(() => {
  const SELECTOR = '[data-section-type="icon-box-owari"]';

  function getCardStep(track) {
    // Find first card and use its width + gap as scroll step
    const grid = track.querySelector('.owari-icon-box__grid');
    const firstItem = grid?.querySelector('.owari-icon-box__item');
    if (!firstItem) return 320;

    const style = window.getComputedStyle(grid);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;

    const rect = firstItem.getBoundingClientRect();
    return Math.max(200, rect.width + gap);
  }

  function updateButtons(track, prevBtn, nextBtn) {
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;

    // Allow slight rounding tolerance
    prevBtn.disabled = x <= 2;
    nextBtn.disabled = x >= (maxScrollLeft - 2);
  }

  function init(sectionEl) {
    const track = sectionEl.querySelector('[data-owari-track]');
    const prevBtn = sectionEl.querySelector('[data-owari-prev]');
    const nextBtn = sectionEl.querySelector('[data-owari-next]');

    // No slider enabled
    if (!track || !prevBtn || !nextBtn) return;

    const scrollTarget = track.querySelector('.owari-icon-box__grid--scroll') || track;

    const onPrev = () => {
      const step = getCardStep(scrollTarget);
      scrollTarget.scrollBy({ left: -step, top: 0, behavior: 'smooth' });
    };

    const onNext = () => {
      const step = getCardStep(scrollTarget);
      scrollTarget.scrollBy({ left: step, top: 0, behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);

    const onUpdate = () => updateButtons(scrollTarget, prevBtn, nextBtn);

    scrollTarget.addEventListener('scroll', () => {
      window.requestAnimationFrame(onUpdate);
    });

    // Resize: critical fix (recompute widths & button state)
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onUpdate, 120);
    });

    // First update
    onUpdate();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  });

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionEl = evt.target?.querySelector?.(SELECTOR) || evt.target;
    if (sectionEl && sectionEl.matches?.(SELECTOR)) init(sectionEl);
  });
})();